import React, { memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import actions from '@src/redux/actions';
import { HISTORY_LABEL, HISTORY_SCOPE } from '@src/constants/history';
import useKaraokeEnabled from '@src/hooks/useKaraokeEnabled';
import { StyledStyleConfig } from './index.style';
import PositionGroup from './PositionGroup';
import TextGroup from './TextGroup';
import LayoutGroup from './LayoutGroup';
import BackgroundGroup from './BackgroundGroup';
import ShadowGroup from './ShadowGroup';
import HighlightGroup from './HighlightGroup';

const StyleConfig = () => {
  const dispatch = useDispatch();
  const config = useSelector(
    (state) => state.project.videoSettings?.captionStyle?.config,
  );
  const karaokeEnabled = useKaraokeEnabled();

  const handleChange = useCallback(
    (group, patch) =>
      dispatch(
        actions.project.updateCaptionStyle(group, patch, {
          history: {
            commit: true,
            scope: HISTORY_SCOPE.DUBBING,
            label: HISTORY_LABEL.CHANGE_CAPTION_STYLE,
          },
        }),
      ),
    [dispatch],
  );

  // Chọn "Không hiển thị phụ đề" thì không có gì để chỉnh.
  if (!config) return null;

  return (
    <StyledStyleConfig>
      <PositionGroup
        position={config.position}
        onChange={(patch) => handleChange('position', patch)}
      />
      <hr className="config-divider" />
      <TextGroup
        text={config.text}
        outline={config.outline}
        onChange={(patch) => handleChange('text', patch)}
        onOutlineChange={(patch) => handleChange('outline', patch)}
      />
      <hr className="config-divider" />
      <LayoutGroup
        layout={config.layout}
        karaokeEnabled={karaokeEnabled}
        onChange={(patch) => handleChange('layout', patch)}
      />
      <hr className="config-divider" />
      <BackgroundGroup
        background={config.background}
        onChange={(patch) => handleChange('background', patch)}
      />
      <hr className="config-divider" />
      <ShadowGroup
        shadow={config.shadow}
        onChange={(patch) => handleChange('shadow', patch)}
      />
      {karaokeEnabled && (
        <>
          <hr className="config-divider" />
          <HighlightGroup
            highlight={config.highlight}
            onChange={(patch) => handleChange('highlight', patch)}
          />
        </>
      )}
    </StyledStyleConfig>
  );
};

export default memo(StyleConfig);
